module.exports = __webpack_public_path__ + "img/sponsors.f3deb684.png";